<template>
  <div class="configurations-view mt-4">
    <div class="row g-4">
      <div class="col-lg-4 col-md-12">
        <div class="card h-100 shadow-sm border-0 config-card">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Configuración general</h6>
              <p class="text-sm text-muted mb-0">Activa o desactiva las funciones principales del usuario.</p>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">GO Card</label>
              <select class="form-control" v-model="configuration.go_card">
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Condonación</label>
              <select class="form-control" v-model="configuration.condonation">
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Verificación de huella</label>
              <select class="form-control" v-model="configuration.finger">
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Prórroga</label>
              <select class="form-control" v-model="configuration.proroga">
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Botón del menú DHL</label>
              <select class="form-control" v-model="configuration.shipping">
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </div>

            <div class="network-box mt-4">
              <label class="form-label fw-bold">Estado de red</label>
              <p class="text-xs text-muted mb-2">Selecciona cómo deseas que se muestre el estado actual del usuario.</p>
              <div class="row g-3 align-items-center">
                <div class="col-md-7">
                  <select class="form-control" v-model="configuration.network_status">
                    <option value="available">Disponible</option>
                    <option value="busy">Ocupado</option>
                    <option value="disconnected">Desconectado</option>
                    <option value="out">Ausente</option>
                  </select>
                </div>
                <div class="col-md-5">
                  <div class="status_preview">
                    <span class="status_circle" :class="status_class"></span>
                    <span class="status_text">{{ networkStatusLabel }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-grid gap-2 mt-4">
              <button class="btn btn-success mb-0" @click="preloadConfiguration">Precargar configuración actual</button>
              <button class="btn btn-danger mb-0" @click="createConfiguration">Guardar toda la configuración</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <div class="card h-100 shadow-sm border-0 config-card">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Configuración de tiempo</h6>
              <p class="text-sm text-muted mb-0">Usa este bloque solo para actualizar el contador de tiempo.</p>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold d-flex justify-content-between align-items-center">
                <span>Días</span>
                <span class="field-limit">Máximo 30</span>
              </label>
              <input type="number" min="0" max="30" class="form-control" v-model.number="configuration.time.day" @change="clampTime('day', 30)">
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold d-flex justify-content-between align-items-center">
                <span>Horas</span>
                <span class="field-limit">Máximo 23</span>
              </label>
              <input type="number" min="0" max="23" class="form-control" v-model.number="configuration.time.hour" @change="clampTime('hour', 23)">
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold d-flex justify-content-between align-items-center">
                <span>Minutos</span>
                <span class="field-limit">Máximo 59</span>
              </label>
              <input type="number" min="0" max="59" class="form-control" v-model.number="configuration.time.minute" @change="clampTime('minute', 59)">
            </div>

            <div class="time-summary-box mb-4">
              <span class="time-summary-label">Vista previa</span>
              <strong>{{ configuration.time.day }} días · {{ configuration.time.hour }} horas · {{ configuration.time.minute }} minutos</strong>
            </div>

            <button class="btn btn-primary w-100 mb-0" @click="updateTime">Actualizar solo el tiempo</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <div class="card shadow-sm border-0 config-card mb-4">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Configuración actual del usuario</h6>
              <p class="text-sm text-muted mb-0">Resumen de lo que está guardado en este momento.</p>
            </div>

            <ul v-if="user_configuration" class="summary-list mb-0">
              <li>
                <span>GO Card</span>
                <strong>{{ user_configuration.go_card ? 'ACTIVO' : 'INACTIVO' }}</strong>
              </li>
              <li>
                <span>Condonación</span>
                <strong>{{ user_configuration.condonation ? 'ACTIVO' : 'INACTIVO' }}</strong>
              </li>
              <li>
                <span>Verificación de huella</span>
                <strong>{{ user_configuration.finger ? 'ACTIVO' : 'INACTIVO' }}</strong>
              </li>
              <li>
                <span>Botón del menú DHL</span>
                <strong>{{ user_configuration.shipping ? 'ACTIVO' : 'INACTIVO' }}</strong>
              </li>
              <li>
                <span>Tiempo</span>
                <strong>{{ user_configuration.time.day }} días · {{ user_configuration.time.hour }} horas · {{ user_configuration.time.minute }} minutos</strong>
              </li>
              <li>
                <span>Red activa</span>
                <strong>{{ getNetworkStatusLabel(user_configuration.network_status) }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="card shadow-sm border-0 config-card info-card">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">¿Qué hace cada acción?</h6>
              <p class="text-sm text-muted mb-0">Guía rápida para no confundirte al usar esta pantalla.</p>
            </div>

            <ul class="info-list mb-0">
              <li>
                <strong>Guardar toda la configuración:</strong>
                guarda lo que ves actualmente cargado en el formulario.
              </li>
              <li>
                <strong>Precargar configuración actual:</strong>
                trae la configuración guardada del usuario y la vuelve a poner en el formulario.
              </li>
              <li>
                <strong>Actualizar solo el tiempo:</strong>
                modifica únicamente el contador de tiempo sin afectar el resto de las opciones.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "Configurations",
  data: () =>({
    user_id:null,
    current_status: 'out',
    configuration: {
      go_card:false,
      condonation:false,
      finger: false,
      proroga: false,
      shipping: false,
      matrix: false,
      network_status: false,
      time: {
        day: 0,
        hour: 0,
        minute: 0,
      }
    },
    user_configuration: null
  }),
  mounted() {
    this.user_id = this.$route.query.id
    this.getConfiguration()
  },
  computed: {
    status_class() {
      return `status_${this.current_status}`;
    },
    networkStatusLabel() {
      return this.getNetworkStatusLabel(this.current_status);
    },
  },
  methods:{
    getNetworkStatusLabel(status) {
      const labels = {
        available: 'Disponible',
        busy: 'Ocupado',
        disconnected: 'Desconectado',
        out: 'Ausente',
      }
      return labels[status] || 'Sin definir'
    },
    async createConfiguration(){
      this.$swal({
        html: '¿Deseas guardar la información?',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post(`user-configurations/create`,{
            user:this.user_id,
            ...this.configuration
          })
          this.configuration = {
            go_card:false,
            condonation:false,
            finger: false,
            proroga: false,
            shipping: false,
            matrix: false,
            network_status: false,
            time: {
              day: 0,
              hour: 0,
              minute: 0,
            }
          }
          await this.getConfiguration()
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      })
    },
    async getConfiguration(){
      const {data} = await get(`user-configurations/by-user?id=${this.user_id}`)
      this.user_configuration = data
      this.configuration.network_status= data.network_status
    },
    async preloadConfiguration(){
      await this.getConfiguration()
      if(this.user_configuration){
        this.configuration = JSON.parse(JSON.stringify(this.user_configuration))
      }
    },
    async updateTime(){
      await post(`user-configurations/update-time`,{
        user:this.user_id,
        time: {
          day: this.configuration.time.day,
          hour: this.configuration.time.hour,
          minute: this.configuration.time.minute,
        }
      })
      this.configuration = {
        go_card:false,
        condonation:false,
        finger: false,
        proroga: false,
        shipping: false,
        matrix: false,
        network_status: false,
        time: {
          day: 0,
          hour: 0,
          minute: 0,
        }
      }
      await this.getConfiguration()
      this.$swal({
        html: 'Procesado con éxito',
        icon: 'success',
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  },
  watch: {
    'configuration.network_status'(new_status) {
      this.current_status = new_status;
    },
  },
}
</script>

<style scoped lang="scss">
.config-card {
  border-radius: 1rem;
}

.section-heading h6 {
  font-size: 1rem;
  font-weight: 700;
}

.form-label {
  margin-bottom: 0.45rem;
  color: #344767;
}

.field-limit {
  font-size: 0.75rem;
  color: #ea0606;
  font-weight: 700;
}

.network-box,
.time-summary-box {
  padding: 1rem;
  border-radius: 0.75rem;
  background: #f8f9fa;
}

.time-summary-box {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.time-summary-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8392ab;
  font-weight: 700;
}

.status_preview {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 100%;
}

.status_circle {
  display: inline-block;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.status_available {
  background-color: green;
}

.status_busy {
  background-color: red;
}

.status_disconnected {
  background-color: gray;
}

.status_out {
  background-color: orange;
}

.status_text {
  font-size: 14px;
  font-weight: 600;
  color: #344767;
}

.summary-list,
.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.summary-list li {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #edf2f7;
}

.summary-list li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.summary-list span {
  color: #67748e;
}

.summary-list strong {
  text-align: right;
  color: #344767;
}

.info-card {
  background: #f8f9fa;
}

.info-list li {
  color: #67748e;
  line-height: 1.65;
  margin-bottom: 0.85rem;
}

.info-list li:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .summary-list li {
    flex-direction: column;
    gap: 0.35rem;
  }

  .summary-list strong {
    text-align: left;
  }
}
</style>
